import { createSlice } from "@reduxjs/toolkit";
// import { getFromServerTopic } from "@utility/slice.js";
import { IDLE } from "@src/constants.js";

const SLICE = "sandbox";

const initialState = {
  status: IDLE,
  userMessages: [],
};

const sandboxSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {},
  extraReducers: {},
});

export default sandboxSlice.reducer;
